import React from 'react';

import BrandPrototype from './methodology-brand-system-prototype.jsx';

const RecommendationPage = () => {
  return <BrandPrototype />;
};

export default RecommendationPage;
